import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useContext, useEffect } from 'react';
import { View, Text, Pressable, ImageBackground } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { RichText } from '../../RichText/rn';
import voucherFrame from '../../../assets/images/voucher-frame.png';
import Divider from './Divider';
import LogoIcon from './LogoIcon';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { ButtonEvents } from '../../../types';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
export var LateDeliveryVoucher = function LateDeliveryVoucher(props) {
  var title = props.title,
    issueDesc = props.issueDesc,
    vouchers = props.vouchers,
    disableBtn = props.disableBtn;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    richTextWidth = _useState2[0],
    setRichTextWidth = _useState2[1];
  var _useComponentTracking = useComponentTracking(props),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    cardTracking = _useComponentTracking2.card,
    voucherTracking = _useComponentTracking2.voucher;
  return /*#__PURE__*/React.createElement(View, _extends({
    style: Styles.container
  }, cardTracking === null || cardTracking === void 0 ? void 0 : cardTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: Styles.head
  }, /*#__PURE__*/React.createElement(LogoIcon, null), /*#__PURE__*/React.createElement(Text, {
    style: Styles.title,
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, title)), /*#__PURE__*/React.createElement(RichText, {
    content: issueDesc,
    defaultWidth: richTextWidth
  }), /*#__PURE__*/React.createElement(View, {
    style: Styles.content,
    onLayout: function onLayout(e) {
      var width = e.nativeEvent.layout.width;
      setRichTextWidth(width);
    }
  }, vouchers.map(function (voucher) {
    var _ref = voucher || {},
      voucherParams = _ref.voucherParams;
    return /*#__PURE__*/React.createElement(Voucher, {
      key: voucherParams.voucherCode,
      voucherInfo: voucher,
      disableBtn: disableBtn,
      tracker: tracker,
      voucherTracking: voucherTracking
    });
  })));
};
var Voucher = function Voucher(props) {
  var context = useContext(ConfigContext);
  var voucherInfo = props.voucherInfo,
    disableBtn = props.disableBtn,
    tracker = props.tracker,
    voucherTracking = props.voucherTracking;
  var _ref2 = voucherInfo || {},
    voucherParams = _ref2.voucherParams;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    used = _useState4[0],
    setUsed = _useState4[1];
  useEffect(function () {
    var _context$eventEmitter;
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.on('updateVoucher', function (voucher) {
      console.log('chatbot ui gets updateVoucher event', voucher);
      if (voucher.voucherCode === (voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.voucherCode)) {
        setUsed(voucher.used);
      }
    });
  }, []);
  var handleUse = function handleUse() {
    var _context$eventEmitter2, _context$eventEmitter3;
    (voucherTracking === null || voucherTracking === void 0 ? void 0 : voucherTracking.trackingClick) && (tracker === null || tracker === void 0 ? void 0 : tracker.click(voucherTracking === null || voucherTracking === void 0 ? void 0 : voucherTracking.trackingClick));
    if (voucherInfo !== null && voucherInfo !== void 0 && voucherInfo.isClaimed || disableBtn || used) {
      return;
    }
    context === null || context === void 0 ? void 0 : (_context$eventEmitter2 = context.eventEmitter) === null || _context$eventEmitter2 === void 0 ? void 0 : (_context$eventEmitter3 = _context$eventEmitter2.emit) === null || _context$eventEmitter3 === void 0 ? void 0 : _context$eventEmitter3.call(_context$eventEmitter2, ButtonEvents.Redirection, {
      text: '',
      action: {
        url_info: {
          url: 'voucher_pages',
          uri_extra: {
            promotionid: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.promotionId,
            voucherCode: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.voucherCode,
            signature: voucherParams === null || voucherParams === void 0 ? void 0 : voucherParams.signature
          }
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(ImageBackground, {
    source: voucherFrame,
    style: Styles.voucherFrame,
    resizeMode: "stretch"
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles.voucher
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles.voucherName,
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.name), /*#__PURE__*/React.createElement(Text, {
    style: Styles.voucherDesc,
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.desc), /*#__PURE__*/React.createElement(Text, {
    style: Styles.voucherValid,
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.valid), /*#__PURE__*/React.createElement(View, {
    style: Styles.divider
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(View, {
    style: Styles.voucherRight
  }, /*#__PURE__*/React.createElement(Pressable, {
    style: [Styles.useBtn, ((voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.isClaimed) || disableBtn || used) && Styles.greyUseBtn],
    onPress: handleUse
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles.useBtnText
  }, voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.btnText)))));
};
var Styles = CustomStyleSheet({
  container: {
    backgroundColor: '#fff',
    paddingTop: 6,
    paddingHorizontal: 10,
    paddingBottom: 10 // alignItems: 'center',
    // borderWidth: 2,
    // borderColor: 'red',
    // width: 300,
  },

  head: {
    flexDirection: 'row',
    height: 14,
    marginBottom: 8
  },
  title: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    marginLeft: 4,
    maxWidth: '80%'
  },
  content: {
    marginTop: 5 // width: 280,
    // minHeight: 68,
    // borderWidth: 1,
    // borderColor: 'red',
  },

  voucher: {
    height: 78,
    position: 'relative',
    paddingTop: 15,
    paddingLeft: 24 // paddingRight: 16,
    // borderWidth: 1,
    // borderColor: 'green',
  },

  voucherFrame: {
    // width: '100%',
    // height: 72,
    // flex: 1,
    // backgroundColor: 'red',
    // position: 'absolute',
    // top: 0,
    left: -2 // transform: [{ scaleX: 1.5 }],
  },

  voucherName: {
    color: '#EE4D2D',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 16,
    marginBottom: 3,
    maxWidth: '80%'
  },
  voucherDesc: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    marginBottom: 3,
    maxWidth: '70%'
  },
  voucherValid: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 10,
    fontWeight: '400',
    lineHeight: 12,
    maxWidth: '70%'
  },
  useBtn: {
    // width: 52,
    paddingHorizontal: 10,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 4,
    borderColor: '#EE4D2D' // position: 'absolute',
    // top: 28,
    // right: 20,
  },

  greyUseBtn: {
    opacity: 0.4
  },
  useBtnText: {
    color: '#EE4D2D',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14
  },
  divider: {
    width: 2,
    height: 68,
    position: 'absolute',
    top: 6,
    right: 84
  },
  voucherRight: {
    width: 84,
    height: 68,
    position: 'absolute',
    top: 6,
    right: 4,
    justifyContent: 'center',
    alignItems: 'center'
  }
});